import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { Grid, InputAdornment, Link, Typography } from '@material-ui/core';
import { useState } from 'react';
import { TextFieldElement } from 'react-hook-form-mui';
import { CustomTooltip, useStyles } from '../CustomTooltip';
import { BudgetInputProps } from '../types';
import { validateQuestion } from '../utils/checks';

export function BudgetInput(props: BudgetInputProps) {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = new WorkloadClient(configApi, oauthApi);
  const label = 'Monthly budget';
  const [formatError, setFormatError] = useState('');

  let placeholder = `${label} *`;
  if (props.existingBudgetAmount) {
    placeholder = `Current Budget: $${props.existingBudgetAmount}`;
  }

  return (
    <Grid container style={{ padding: 10 }} justifyContent="space-between">
      <Grid item xs={11}>
        <TextFieldElement
          disabled={props.disabled}
          name="budget"
          label={label}
          variant="outlined"
          className={classes.root}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          placeholder={placeholder}
          validation={{
            validate: async value => {
              const regex: RegExp = /^[0-9]+\.[0-9]{2}$/;
              if (value && !regex.test(value)) {
                setFormatError("Please enter a budget in the format '0.00'");
                return false;
              } else if (value && props.apiValidation) {
                return await validateQuestion(
                  'budget',
                  value,
                  props.apiValidation!,
                  workloadClient,
                  props.nonGovernanceValidation,
                );
              }
              return true;
            },
          }}
          parseError={error => {
            return error?.message || formatError;
          }}
          fullWidth
          required
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              Will create an alarm to alert workload owners if the budget is
              exceeded. This will not stop you from exceeding the specified
              value. For more information on setting an accurate budget,{' '}
              <Link
                target="_blank"
                href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/design/finops/tools/aws-budgeting/#best-practices-and-tools-to-determine-budget"
              >
                read the guidance here
              </Link>
              .
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
